// extracted by mini-css-extract-plugin
export default {"container":"Button_container__kM7Jm","secondary":"Button_secondary__xqvKj","icon":"Button_icon__e267e","loader":"Button_loader__hHqt5","active":"Button_active__hpl40"};